import type { ActivityMessage, ToolApproval } from "@/api/models"

import { ActivityMessageHistory } from "./activity-message/activity-message-history"
import { SystemMessageLayout } from "./system-message-layout"

export type LoadingProps = {
  message?: string
  activityMessages?: ActivityMessage[]
  citationSection?: string
  toolApprovals?: ToolApproval[]
}

export function Loading({
  message,
  activityMessages = [],
  citationSection,
  toolApprovals,
}: LoadingProps) {
  // Only render a custom message line when callers pass one and no activities
  // have arrived yet. The TTFT placeholder ("Tänker...") is now rendered by
  // ActivityMessageHistory's header without text animation, so
  // we don't render the generic placeholder here anymore — only caller-supplied
  // messages like upload progress or time-remaining estimates.
  const showCustomMessage = Boolean(message) && activityMessages.length === 0

  return (
    <SystemMessageLayout data-testid="chat-loading">
      <SystemMessageLayout.Content>
        <ActivityMessageHistory
          citationSection={citationSection}
          id="loading-activity"
          isDefaultOpen={false}
          isLoading={true}
          messages={activityMessages}
          toolApprovals={toolApprovals}
        />
        {showCustomMessage && (
          <section className="flex w-full flex-col gap-1">
            <div className="text-muted-foreground text-sm">
              <span>{message}</span>
              <span className="streaming-cursor" />
            </div>
          </section>
        )}
      </SystemMessageLayout.Content>
    </SystemMessageLayout>
  )
}
